import { combineReducers } from "redux";

import * as originalsReducer from "./originals";
import * as editadesReducer from "./editades";
import * as errorsReducer from "./mostrarErrors";
import * as formulariEnCursReducer from "./peticioEnviarFormulariEnCurs";

const rootReducer = combineReducers({
  originals: originalsReducer.default,
  editades: editadesReducer.default,
  mostrarErrors: errorsReducer.default,
  peticioEnviarFormulariEnCurs: formulariEnCursReducer.default
});

export default rootReducer;
